import React from 'react';

const QuickSearchInitialTab = ({ sectionList }) => {
  return (
    <div className="container h-screen w-screen max-w-[1888px] md:h-[660px] lg:w-full lg:px-6 xl:px-8">
      <div className="grid grid-cols-1 pt-5 sm:grid-cols-2">
        {sectionList.map((listItem, index) => (
          <div
            key={listItem.sectionTitle + index}
            className="flex flex-col"
          >
            <h4 className="h4 py-1 text-gray-700">
              {listItem.sectionTitle}
            </h4>
            {listItem.sectionLinkList.map((subListItem, index) => (
              <a
                className="underlined-link mt-1 self-start py-1 font-garamond text-lg text-gray-500 lg:text-xl [&:first-child]:mt-0"
                key={'quick-search-initial' + subListItem.href + index}
                href={subListItem.href}
              >
                {subListItem.text}
              </a>
            ))}
            {listItem.searchLinkEditorField && (
              <div
                className="[&_a]:underlined-link [&_a]:mt-1 [&_a]:self-start [&_a]:py-1 [&_a]:font-garamond [&_a]:text-lg [&_a]:text-gray-500 [&_a]:lg:text-xl [&_p]:mt-1"
                dangerouslySetInnerHTML={{
                  __html: listItem.searchLinkEditorField.value,
                }}
              ></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickSearchInitialTab;
